import API from '../api';

/** Admin-only license capacity and usage (read-only). */
export const getAdminLicense = () =>
  API.get('/admin/license').then((r) => r.data);
